import { makeStyles } from '@material-ui/core';

export const useSendReminderStyles = makeStyles(() => ({
    root: {
        lineHeight: '23px',
    },
}));
